import type { ContactData } from ".";

export class Contact {
  first_name: string;
  last_name: string;
  image?: string | null;

  constructor(contact: ContactData) {
    this.first_name = contact?.first_name || "";
    this.last_name = contact?.last_name || "";
    this.image = contact?.image?.urls.thumbnail;
  }

  get full_name(): string {
    return [this.first_name, this.last_name].filter((n) => n).join(" ");
  }
}
